(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("6shAo", function(module, exports) {

$parcel$export(module.exports, "querySelectorAll", function () { return $4b32ffcf2d75510a$export$2e83b5c43fb7af7b; });
$parcel$export(module.exports, "appendBottomBar", function () { return $4b32ffcf2d75510a$export$c8603593494de511; });
$parcel$export(module.exports, "getElements", function () { return $4b32ffcf2d75510a$export$73eac51a39d6b0eb; });
$parcel$export(module.exports, "Content", function () { return $4b32ffcf2d75510a$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "Entrypoint", function () { return $4b32ffcf2d75510a$export$7593eb0107a6096b; });
$parcel$export(module.exports, "render", function () { return $4b32ffcf2d75510a$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "goTo", function () { return $4b32ffcf2d75510a$export$95e8d77caafa3e06; });
$parcel$export(module.exports, "initSmartnav", function () { return $4b32ffcf2d75510a$export$8d4a4a389ba6cafa; });
$parcel$export(module.exports, "init", function () { return $4b32ffcf2d75510a$export$2cd8252107eb640b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $hfCPd = parcelRequire("hfCPd");

var $2gwg0 = parcelRequire("2gwg0");

var $kJhYp = parcelRequire("kJhYp");

var $gS5nW = parcelRequire("gS5nW");

var $dJ00A = parcelRequire("dJ00A");

var $9rqV0 = parcelRequire("9rqV0");

var $IFWJb = parcelRequire("IFWJb");

var $14nsI = parcelRequire("14nsI");

var $insiF = parcelRequire("insiF");

var $7GW0c = parcelRequire("7GW0c");

var $b5aRK = parcelRequire("b5aRK");

var $i6QHm = parcelRequire("i6QHm");

var $4j4tH = parcelRequire("4j4tH");

var $dJhID = parcelRequire("dJhID");

var $5bEXW = parcelRequire("5bEXW");

var $8L1B1 = parcelRequire("8L1B1");

var $jjS2R = parcelRequire("jjS2R");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $g6HwJ = parcelRequire("g6HwJ");

var $aSJcu = parcelRequire("aSJcu");

var $hO3nk = parcelRequire("hO3nk");

var $cdK26 = parcelRequire("cdK26");

var $gSZul = parcelRequire("gSZul");

var $2ZaET = parcelRequire("2ZaET");

var $lihS4 = parcelRequire("lihS4");

var $6e14p = parcelRequire("6e14p");

var $8E2YL = parcelRequire("8E2YL");

var $6EwcS = parcelRequire("6EwcS");

var $gUsPc = parcelRequire("gUsPc");

var $5BWWq = parcelRequire("5BWWq");

var $hm3Un = parcelRequire("hm3Un");
function $4b32ffcf2d75510a$export$2e83b5c43fb7af7b(selector) {
    return $i7mYY.keepMap($i7mYY.map(Array.prototype.slice.call(document.querySelectorAll(selector)), $b5aRK.ofNode), function(node) {
        return node;
    });
}
function $4b32ffcf2d75510a$export$c8603593494de511(param) {
    var element = document.createElement("div");
    element.id = "maker-smartnav";
    $2whNH.forEach($7GW0c.$$Document.body(document), function(param) {
        param.appendChild(element);
    });
    return element;
}
function $4b32ffcf2d75510a$export$73eac51a39d6b0eb(param) {
    var foundLauncher = $4b32ffcf2d75510a$export$2e83b5c43fb7af7b("#maker-smartnav-launcher");
    var foundSection = $4b32ffcf2d75510a$export$2e83b5c43fb7af7b("#maker-smartnav-section");
    var foundPDP = $4b32ffcf2d75510a$export$2e83b5c43fb7af7b("#maker-smartnav-pdp");
    var foundBottombar = foundPDP.length === 0 ? $4b32ffcf2d75510a$export$2e83b5c43fb7af7b("#maker-smartnav") : [];
    var foundElements = $i7mYY.concat($i7mYY.concat($i7mYY.concat(foundBottombar, foundLauncher), foundSection), foundPDP);
    var hasSmartNavElements = foundElements.length !== 0;
    var pagesModal = document.querySelector("#maker-modal");
    var isShopifyShop = $2whNH.isSome($2gwg0.getShop(undefined));
    var isAltFunnel = $dJ00A.isAltFunnel(undefined);
    var isPagesModalAbsent = $2whNH.isNone(pagesModal == null ? undefined : $loT9g.some(pagesModal));
    var elementsToUse = hasSmartNavElements ? foundElements : isShopifyShop && isPagesModalAbsent || isAltFunnel && isPagesModalAbsent ? [
        $4b32ffcf2d75510a$export$c8603593494de511(undefined)
    ] : [];
    return $i7mYY.map(elementsToUse, $dJ00A.setupAltFunnelElement);
}
function $4b32ffcf2d75510a$var$Entrypoint$Content(Props) {
    var embedType = Props.embedType;
    var configId = Props.configId;
    var onOpenLink = Props.onOpenLink;
    var attributes = Props.attributes;
    var isStyleLoaded = $6e14p.useIsStyleLoaded(undefined);
    var match = $hBcYV.useRouter(undefined);
    var previewMode = match.previewMode;
    var match$1 = $8E2YL.use(undefined);
    var config = match$1.config;
    $g85JO.useEffect(function() {
        $iv6Yc._1($insiF.preload, undefined);
    }, []);
    var isBottombarEnabled = $gS5nW.isSmartBarEnabled(embedType);
    var tmp;
    switch(embedType){
        case /* Bottombar */ 0:
            var tmp$1 = {
                configId: configId,
                embedType: embedType,
                enabled: isBottombarEnabled
            };
            if (onOpenLink !== undefined) tmp$1.onOpenLink = $loT9g.valFromOption(onOpenLink);
            if (attributes !== undefined) tmp$1.attributes = $loT9g.valFromOption(attributes);
            tmp = /*#__PURE__*/ $g85JO.createElement($gSZul.make, tmp$1);
            break;
        case /* Launcher */ 2:
            var tmp$2 = {
                configId: configId,
                embedType: embedType
            };
            if (onOpenLink !== undefined) tmp$2.onOpenLink = $loT9g.valFromOption(onOpenLink);
            if (attributes !== undefined) tmp$2.attributes = $loT9g.valFromOption(attributes);
            tmp = /*#__PURE__*/ $g85JO.createElement($hO3nk.make, tmp$2);
            break;
        case /* Section */ 3:
            var tmp$3 = {
                configId: configId,
                embedType: embedType
            };
            if (onOpenLink !== undefined) tmp$3.onOpenLink = $loT9g.valFromOption(onOpenLink);
            if (attributes !== undefined) tmp$3.attributes = $loT9g.valFromOption(attributes);
            tmp = /*#__PURE__*/ $g85JO.createElement($g6HwJ.make, tmp$3);
            break;
        case /* Inline */ 1:
        case /* Menu */ 4:
            tmp = null;
            break;
        case /* ProductDetailsPage */ 5:
            var tmp$4 = {
                configId: configId,
                embedType: embedType
            };
            if (onOpenLink !== undefined) tmp$4.onOpenLink = $loT9g.valFromOption(onOpenLink);
            if (attributes !== undefined) tmp$4.attributes = $loT9g.valFromOption(attributes);
            tmp = /*#__PURE__*/ $g85JO.createElement($14nsI.make, tmp$4);
            break;
    }
    var tmp$5 = {
        forceEffectiveness: embedType === /* ProductDetailsPage */ 5,
        children: /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: isStyleLoaded,
            children: /*#__PURE__*/ $g85JO.createElement($8L1B1.make, {
                config: config,
                children: /*#__PURE__*/ $g85JO.createElement($IFWJb.Provider.make, {
                    children: tmp
                })
            })
        })
    };
    if (attributes !== undefined) tmp$5.attributes = $loT9g.valFromOption(attributes);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($i6QHm.make, {
        embedType: embedType
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: $7bjme.notequal(previewMode, /* PreviewLive */ 1) && previewMode !== undefined,
        children: /*#__PURE__*/ $g85JO.createElement($4j4tH.make, {})
    }), /*#__PURE__*/ $g85JO.createElement($6EwcS.make, {
        configId: config.id,
        accountId: config.accountId,
        historyEnabled: config.settings.historyEnabled,
        favoritesEnabled: config.settings.favoritesEnabled,
        children: /*#__PURE__*/ $g85JO.createElement($lihS4.make, {
            children: /*#__PURE__*/ $g85JO.createElement($gUsPc.make, tmp$5)
        })
    }));
}
$4b32ffcf2d75510a$var$Entrypoint$Content.displayName = "Entrypoint.Content";
var $4b32ffcf2d75510a$var$make = /*#__PURE__*/ $g85JO.memo($4b32ffcf2d75510a$var$Entrypoint$Content);
var $4b32ffcf2d75510a$export$7c6e2c02157bb7d2 = {
    make: $4b32ffcf2d75510a$var$make
};
function $4b32ffcf2d75510a$var$Entrypoint$Entrypoint(Props) {
    var configId = Props.configId;
    var embedTypeOpt = Props.embedType;
    var attributes = Props.attributes;
    var element = Props.element;
    var trackers = Props.trackers;
    var onAddToCart = Props.onAddToCart;
    var onOpenLink = Props.onOpenLink;
    var embedType = embedTypeOpt !== undefined ? embedTypeOpt : /* Bottombar */ 0;
    var attributes$1 = $9rqV0.Attributes.useAttributesObserver(element, attributes);
    var accountId = $2whNH.flatMap(attributes$1, function(attr) {
        return attr.account;
    });
    var namespace = $9rqV0.getNamespace(attributes$1);
    var isInlineElementOnThePage = function isInlineElementOnThePage(param) {
        return $4b32ffcf2d75510a$export$2e83b5c43fb7af7b("#maker-smartnav-inline, [data-maker-smartnav-inline='true']").length !== 0;
    };
    var match = $g85JO.useState(function() {
        return isInlineElementOnThePage(undefined);
    });
    var setInlineExists = match[1];
    var allowMultipleEmbeds = window.makerAllowMultipleEmbeds || false;
    $g85JO.useEffect(function() {
        var handleRender = function handleRender(param) {
            $iv6Yc._1(setInlineExists, function(param) {
                return isInlineElementOnThePage(undefined);
            });
        };
        document.addEventListener("maker-smartnav-inline-rendered", handleRender);
        return function(param) {
            document.removeEventListener("maker-smartnav-inline-rendered", handleRender);
        };
    }, []);
    $g85JO.useEffect(function() {
        if (!$cdK26.isProductPage(undefined)) $hm3Un.clearLastCategory(undefined);
    }, []);
    if (match[0] && !allowMultipleEmbeds) return null;
    var tmp = {
        embedType: embedType,
        configId: configId
    };
    if (onOpenLink !== undefined) tmp.onOpenLink = $loT9g.valFromOption(onOpenLink);
    if (attributes$1 !== undefined) tmp.attributes = $loT9g.valFromOption(attributes$1);
    var tmp$1 = {
        children: /*#__PURE__*/ $g85JO.createElement($6e14p.make, $6e14p.makeProps(/*#__PURE__*/ $g85JO.createElement($5BWWq.make, {
            value: {
                accountId: accountId,
                trackers: trackers,
                onAddToCart: onAddToCart,
                onOpenLink: onOpenLink
            },
            children: /*#__PURE__*/ $g85JO.createElement($aSJcu.Provider.make, {
                children: /*#__PURE__*/ $g85JO.createElement($hBcYV.make, {
                    configId: configId,
                    embedType: embedType,
                    children: /*#__PURE__*/ $g85JO.createElement($8E2YL.make, {
                        configId: configId,
                        children: /*#__PURE__*/ $g85JO.createElement($hfCPd.Provider.make, {
                            children: /*#__PURE__*/ $g85JO.createElement($4b32ffcf2d75510a$var$make, tmp)
                        }),
                        enableTrimmingTreeByReferrer: false
                    })
                })
            })
        }), undefined, undefined))
    };
    if (namespace !== undefined) tmp$1.namespace = $loT9g.valFromOption(namespace);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.StrictMode, {
        children: /*#__PURE__*/ $g85JO.createElement($efwy1.Provider.make, tmp$1)
    });
}
$4b32ffcf2d75510a$var$Entrypoint$Entrypoint.displayName = "Entrypoint.Entrypoint";
var $4b32ffcf2d75510a$export$7593eb0107a6096b = {
    make: $4b32ffcf2d75510a$var$Entrypoint$Entrypoint
};
function $4b32ffcf2d75510a$export$b3890eb0ae9dca99(configId, onOpenLink, onAddToCart, trackers, isLauncher, element, attributes) {
    var elementId = element.id;
    var newDictEntry = [
        [
            elementId,
            element
        ]
    ];
    var embedType = $2whNH.map(attributes, function(attr) {
        return attr.embedType;
    });
    var attributes$1 = $2whNH.map(attributes, function(attr) {
        return attr.attributes;
    });
    var embedType$1 = $2whNH.getWithDefault(embedType, isLauncher ? /* Launcher */ 2 : /* Bottombar */ 0);
    var elements;
    switch(embedType$1){
        case /* Launcher */ 2:
            elements = window.smartNavElementsLauncher;
            break;
        case /* Section */ 3:
            elements = window.smartNavElementsSection;
            break;
        case /* Bottombar */ 0:
        case /* Inline */ 1:
        case /* Menu */ 4:
            elements = window.smartNavElements;
            break;
        case /* ProductDetailsPage */ 5:
            elements = window.smartNavElementsPDP;
            break;
    }
    var setElement;
    var exit = 0;
    switch(embedType$1){
        case /* Launcher */ 2:
            setElement = function setElement(prim0, prim1) {
                prim0.smartNavElementsLauncher = prim1;
            };
            break;
        case /* Section */ 3:
            setElement = function setElement(prim0, prim1) {
                prim0.smartNavElementsSection = prim1;
            };
            break;
        case /* Bottombar */ 0:
        case /* Inline */ 1:
        case /* Menu */ 4:
            exit = 1;
            break;
        case /* ProductDetailsPage */ 5:
            setElement = function setElement(prim0, prim1) {
                prim0.smartNavElementsPDP = prim1;
            };
            break;
    }
    if (exit === 1) setElement = function setElement(prim0, prim1) {
        prim0.smartNavElements = prim1;
    };
    try {
        $2whNH.forEach($2whNH.keep(elements, function(param) {
            return embedType$1 !== /* Section */ 3;
        }), function(smartNavElements) {
            $2whNH.forEach($d3YYW.get(smartNavElements, elementId), $5bEXW.unmountComponentAtNode);
        });
    } catch (exn) {}
    $iv6Yc._2(setElement, window, $2whNH.mapWithDefault(elements, $d3YYW.fromArray(newDictEntry), function(elements) {
        return $d3YYW.fromArray($i7mYY.concat($d3YYW.entries(elements), newDictEntry));
    }));
    var tmp = {
        configId: configId,
        embedType: embedType$1,
        element: element,
        key: configId
    };
    if (attributes$1 !== undefined) tmp.attributes = $loT9g.valFromOption(attributes$1);
    if (trackers !== undefined) tmp.trackers = $loT9g.valFromOption(trackers);
    if (onAddToCart !== undefined) tmp.onAddToCart = $loT9g.valFromOption(onAddToCart);
    if (onOpenLink !== undefined) tmp.onOpenLink = $loT9g.valFromOption(onOpenLink);
    $5bEXW.render(/*#__PURE__*/ $g85JO.createElement($dJhID.make, {
        componentName: "Root",
        children: /*#__PURE__*/ $g85JO.createElement($4b32ffcf2d75510a$var$Entrypoint$Entrypoint, tmp)
    }), element);
}
function $4b32ffcf2d75510a$export$95e8d77caafa3e06(quickView, quickNav, replaceState, preserveScroll, namespace) {
    $kJhYp.goTo(namespace, undefined, quickView, quickNav, replaceState, preserveScroll, undefined);
}
function $4b32ffcf2d75510a$export$8d4a4a389ba6cafa(index, element) {
    return $4b32ffcf2d75510a$var$_initSmartnav.apply(this, arguments);
}
function $4b32ffcf2d75510a$var$_initSmartnav() {
    $4b32ffcf2d75510a$var$_initSmartnav = (0, $5YOUh._)(function(index, element) {
        var attributes, match, embedType, configId;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $9rqV0.Attributes.autoAssignNamespaces(undefined);
                    attributes = $9rqV0.Attributes.fromElement(element);
                    match = element.id;
                    switch(match){
                        case "maker-smartnav-launcher":
                            embedType = /* Launcher */ 2;
                            break;
                        case "maker-smartnav-pdp":
                            embedType = /* ProductDetailsPage */ 5;
                            break;
                        case "maker-smartnav-section":
                            embedType = /* Section */ 3;
                            break;
                        default:
                            embedType = /* Bottombar */ 0;
                    }
                    return [
                        4,
                        $jjS2R.getConfigId(undefined, undefined, undefined, attributes, embedType)
                    ];
                case 1:
                    configId = _state.sent();
                    if (configId !== undefined) return [
                        2,
                        $4b32ffcf2d75510a$export$b3890eb0ae9dca99(configId, undefined, undefined, undefined, embedType === /* Launcher */ 2, element, {
                            embedType: embedType,
                            attributes: attributes
                        })
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $4b32ffcf2d75510a$var$_initSmartnav.apply(this, arguments);
}
function $4b32ffcf2d75510a$export$2cd8252107eb640b(param) {
    var elements = $4b32ffcf2d75510a$export$73eac51a39d6b0eb(undefined);
    if (elements.length !== 0) return $i7mYY.forEachWithIndex(elements, function(index, element) {
        $4b32ffcf2d75510a$export$8d4a4a389ba6cafa(index, element);
    });
    else {
        console.error("Could not initialize SmartNav: no element found");
        return;
    }
}
 /* make Not a pure module */ 
});
parcelRegister("gS5nW", function(module, exports) {

$parcel$export(module.exports, "isSmartBarEnabled", function () { return $c485ddd776de0bab$export$ccbe0f993fadc043; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $cdK26 = parcelRequire("cdK26");
var $c485ddd776de0bab$export$e678e550fcfcad5f = /^\/cart|^\/store\/jump\/static|^\/orderconfirmation|^\/pages\/mattressquiz|^\/collections\/limited-edition/i;
function $c485ddd776de0bab$export$ccbe0f993fadc043(embedType) {
    var isShopifyProductPage = $cdK26.isProductPage(undefined);
    var isBlacklisted = $2whNH.isSome($loT9g.null_to_opt(window.location.pathname.match($c485ddd776de0bab$export$e678e550fcfcad5f)));
    if (embedType !== 0) return true;
    else if (isShopifyProductPage) return false;
    else return !isBlacklisted;
}
 /* No side effect */ 
});

parcelRegister("14nsI", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $0c785d3d6974f0a1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $0c785d3d6974f0a1$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("lsFau"));
});
function $0c785d3d6974f0a1$var$PDPApp_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($0c785d3d6974f0a1$var$component, Props);
}
$0c785d3d6974f0a1$var$PDPApp_Lazy.displayName = "PDPApp_Lazy";
var $0c785d3d6974f0a1$export$dd44f18ab656f3bb = $0c785d3d6974f0a1$var$PDPApp_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("lsFau", function(module, exports) {






















module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9j6sg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5PtUs")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("WepAH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("b6X9u")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hujXY"))
]).then(function() {
    return parcelRequire("cqXmx");
});

});


parcelRegister("insiF", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $d61053c37f0227fa$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $d61053c37f0227fa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $7tAuM = parcelRequire("7tAuM");

var $d61053c37f0227fa$var$component = (0, $7tAuM.lazy)(function() {
    return (parcelRequire("ktODY"));
});
function $d61053c37f0227fa$var$Slider_Lazy(Props) {
    var fallbackOpt = Props.fallback;
    var fallback = fallbackOpt !== undefined ? $loT9g.valFromOption(fallbackOpt) : null;
    var element = /*#__PURE__*/ $g85JO.createElement($d61053c37f0227fa$var$component, Props);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Suspense, {
        children: element,
        fallback: fallback
    });
}
$d61053c37f0227fa$var$Slider_Lazy.displayName = "Slider_Lazy";
var $d61053c37f0227fa$export$513ccb98c53b8039 = $d61053c37f0227fa$var$component.preload;
var $d61053c37f0227fa$export$dd44f18ab656f3bb = $d61053c37f0227fa$var$Slider_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("ktODY", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1CMBB")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5G2Uq"))
]).then(function() {
    return parcelRequire("khdgl");
});

});


parcelRegister("i6QHm", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $d2f1aa58c533da63$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $9rqV0 = parcelRequire("9rqV0");

var $b5aRK = parcelRequire("b5aRK");

var $iCVlB = parcelRequire("iCVlB");
function $d2f1aa58c533da63$var$AdditionalCSS(Props) {
    var embedType = Props.embedType;
    var getIsNavBeingHiddenWithDisplayNone = function getIsNavBeingHiddenWithDisplayNone(param) {
        return $i7mYY.every($i7mYY.map($i7mYY.map(Array.prototype.slice.call(document.querySelectorAll("#" + $9rqV0.getIdByEmbedType(embedType))), $b5aRK.ofNode), function(node) {
            return $2whNH.map(node, function(node) {
                return window.getComputedStyle(node).display;
            });
        }), function(display) {
            return $7bjme.equal(display, "none");
        });
    };
    var match = $g85JO.useState(function() {
        return getIsNavBeingHiddenWithDisplayNone(undefined);
    });
    var setIsNavBeingHiddenWithDisplayNone = match[1];
    $g85JO.useLayoutEffect(function() {
        $iv6Yc._1(setIsNavBeingHiddenWithDisplayNone, function(param) {
            return getIsNavBeingHiddenWithDisplayNone(undefined);
        });
    });
    if (match[0]) return null;
    else return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("style", undefined, "html[lang='en'].QVTW__body-no-scroll body,\n        html.QVTW__body-no-scroll,\n        html[lang='en'].QVTW__body-no-scroll body.production,\n        html.QVTW__body-no-scroll,\n        html.QVTW__body-no-scroll body {\n          overflow: clip !important;\n          overflow-x: clip !important;\n          overflow-y: clip !important;\n          touch-action: none;\n        }\n\n        html.QVTW__body-no-scroll .js-maker-embed[data-sticky] iframe {\n          display: none !important;\n        }"), /*#__PURE__*/ $g85JO.createElement($iCVlB.CustomStyling.make, {}));
}
$d2f1aa58c533da63$var$AdditionalCSS.displayName = "AdditionalCSS";
var $d2f1aa58c533da63$export$dd44f18ab656f3bb = $d2f1aa58c533da63$var$AdditionalCSS;
 /* react Not a pure module */ 
});

parcelRegister("4j4tH", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $322c68ffe6f8f794$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2gEz2 = parcelRequire("2gEz2");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $baORH = parcelRequire("baORH");

var $i7mYY = parcelRequire("i7mYY");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $322c68ffe6f8f794$var$EditorMethods(Props) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $hBcYV.useRouter(undefined);
    var goTo = match$1.goTo;
    var route = match$1.route;
    $baORH.IFrame.useCommandReceiver(undefined, /* RefreshConfig */ 2, function(param) {
        return Promise.all($i7mYY.map($i7mYY.keep(Array.from($2gEz2.Cache.cache.keys()), function(key) {
            return key.includes("/api/get_config");
        }), $2gEz2.revalidate));
    }, []);
    $baORH.IFrame.useCommandReceiver(undefined, /* Open */ 3, function(param) {
        if (typeof route === "number") return $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* Home */ 0,
            _0: {
                homeType: /* Index */ 0,
                filters: undefined,
                sort: undefined
            }
        });
    }, [
        config.id
    ]);
    $g85JO.useEffect(function() {
        $baORH.IFrame.sendCommand0(undefined, /* Ready */ 0);
        return function(param) {
            $baORH.IFrame.sendCommand0(undefined, /* Destroyed */ 1);
        };
    }, [
        config.id
    ]);
    return null;
}
$322c68ffe6f8f794$var$EditorMethods.displayName = "EditorMethods";
var $322c68ffe6f8f794$export$dd44f18ab656f3bb = $322c68ffe6f8f794$var$EditorMethods;
 /* SWR Not a pure module */ 
});

parcelRegister("dJhID", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9fed38edae7c024d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $6Tsgf = parcelRequire("6Tsgf");

var $hmsbi = parcelRequire("hmsbi");

var $hPrj9 = parcelRequire("hPrj9");

var $3GntQ = parcelRequire("3GntQ");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $75ZqT = parcelRequire("75ZqT");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $4QdUt = parcelRequire("4QdUt");
var $9fed38edae7c024d$export$20dc868c9a130faa = $75ZqT.$$Error.fromRescriptWithNewMessage;
var $9fed38edae7c024d$var$_ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $hPrj9._)(_ErrorBoundary, _React_Component);
    var _super = (0, $3GntQ._)(_ErrorBoundary);
    function _ErrorBoundary(props) {
        (0, $6Tsgf._)(this, _ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: false,
            errorInfo: null
        };
        return _this;
    }
    (0, $hmsbi._)(_ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                // If we detect that the error is a rescript exception, we try to extract information out of it,
                // and create a new error object with it's RE_EXN_ID as the message.
                if (typeof error.RE_EXN_ID == "string" && typeof error.Error == "object") error = $9fed38edae7c024d$export$20dc868c9a130faa(error, error.RE_EXN_ID);
                // Do nothing if the error is thrown by parcel script loader.
                // This error usually indicates network issues.
                if (error.message.includes("Failed to fetch dynamically imported module:") || error.message.includes("Cannot find module") || error.message.includes("Could not resolve bundle with id")) return;
                this.setState({
                    error: error,
                    errorInfo: errorInfo
                });
                if (this.props.onError) this.props.onError(error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.error) return this.props.renderFallback ? this.props.renderFallback(this.state.error, this.state.errorInfo) : null;
                else return this.props.children;
            }
        }
    ]);
    return _ErrorBoundary;
}($g85JO.Component);
function $9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary(Props) {
    return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$_ErrorBoundary, Props);
}
$9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary.displayName = "ErrorBoundary.RawErrorBoundary";
var $9fed38edae7c024d$export$e022a45c7a286b77 = {
    make: $9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary
};
function $9fed38edae7c024d$export$b42e70ddca33ff5b(str) {
    if (str !== "") return str;
}
function $9fed38edae7c024d$var$ErrorBoundary$ReportOnce(Props) {
    var error = Props.error;
    var redirect = Props.redirect;
    var componentStack = Props.componentStack;
    var message = Props.message;
    $g85JO.useEffect(function() {
        $4QdUt.critical2(error, {
            message: message,
            componentStack: componentStack
        });
        var timeout = redirect !== undefined ? $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(redirect, undefined);
        }, 0)) : undefined;
        return function(param) {
            $2whNH.forEach(timeout, function(id) {
                clearTimeout(id);
            });
        };
    }, []);
    return null;
}
$9fed38edae7c024d$var$ErrorBoundary$ReportOnce.displayName = "ErrorBoundary.ReportOnce";
var $9fed38edae7c024d$export$f2fa74dfba7f4e57 = {
    make: $9fed38edae7c024d$var$ErrorBoundary$ReportOnce
};
function $9fed38edae7c024d$var$ErrorBoundary(Props) {
    var componentName = Props.componentName;
    var redirect = Props.redirect;
    var children = Props.children;
    var renderFallback = function renderFallback(internalError, info) {
        var cause = $75ZqT.$$Error.fromRescript(internalError);
        var rootCause = $75ZqT.$$Error.getRootCause(cause);
        var rootCauseName = rootCause.name;
        var rootCauseMessage = rootCause.message;
        var culprit = $2whNH.getWithDefault($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.map(info.componentStack, function(__x) {
            return __x.replace(/\n/g, "");
        }), function(__x) {
            return __x.split(" in ");
        }), function(__x) {
            return $i7mYY.get(__x, 1);
        }), function(__x) {
            return __x.replace(/\(([^\)]+)\)/g, "");
        }), function(prim) {
            return prim.trim();
        }), $9fed38edae7c024d$export$b42e70ddca33ff5b), function(culprit) {
            return "<" + culprit + "> crashed, " + componentName + " caught";
        }), componentName + " caught a crash");
        var rootCauseMessage$1 = rootCauseName !== undefined ? rootCauseMessage !== undefined ? "RC: " + rootCauseName + " " + rootCauseMessage : "RC: " + rootCauseName : rootCauseMessage !== undefined ? "RC: " + rootCauseMessage : undefined;
        var message = $i7mYY.keepMap([
            culprit,
            rootCauseMessage$1
        ], function(a) {
            return a;
        }).join(", ");
        var error = $75ZqT.$$Error.fromStringWithCause(message, rootCause);
        var tmp = {
            error: error,
            componentStack: info.componentStack,
            message: message
        };
        if (redirect !== undefined) tmp.redirect = $loT9g.valFromOption(redirect);
        return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$ErrorBoundary$ReportOnce, tmp);
    };
    return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary, {
        children: children,
        renderFallback: renderFallback
    });
}
$9fed38edae7c024d$var$ErrorBoundary.displayName = "ErrorBoundary";
var $9fed38edae7c024d$export$dd44f18ab656f3bb = $9fed38edae7c024d$var$ErrorBoundary;
 /*  Not a pure module */ 
});

parcelRegister("g6HwJ", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $bb9ef86af512793e$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $bb9ef86af512793e$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("gpTYT"));
});
function $bb9ef86af512793e$var$SectionApp_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($bb9ef86af512793e$var$component, Props);
}
$bb9ef86af512793e$var$SectionApp_Lazy.displayName = "SectionApp_Lazy";
var $bb9ef86af512793e$export$dd44f18ab656f3bb = $bb9ef86af512793e$var$SectionApp_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("gpTYT", function(module, exports) {




























module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9j6sg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("cYw4f")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("b6X9u")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1CMBB")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fRua9")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5PtUs")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("4aK9x"))
]).then(function() {
    return parcelRequire("9HhFF");
});

});


parcelRegister("hO3nk", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $cf69b973fcd96f05$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $cf69b973fcd96f05$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("h8qgt"));
});
function $cf69b973fcd96f05$var$LauncherApp_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($cf69b973fcd96f05$var$component, Props);
}
$cf69b973fcd96f05$var$LauncherApp_Lazy.displayName = "LauncherApp_Lazy";
var $cf69b973fcd96f05$export$dd44f18ab656f3bb = $cf69b973fcd96f05$var$LauncherApp_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("h8qgt", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("b6X9u")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1CMBB")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fRua9")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5Jza1"))
]).then(function() {
    return parcelRequire("4jlPh");
});

});


parcelRegister("gSZul", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c4b162cf14bff716$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $c4b162cf14bff716$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("eai7O"));
});
function $c4b162cf14bff716$var$BottombarApp_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($c4b162cf14bff716$var$component, Props);
}
$c4b162cf14bff716$var$BottombarApp_Lazy.displayName = "BottombarApp_Lazy";
var $c4b162cf14bff716$export$dd44f18ab656f3bb = $c4b162cf14bff716$var$BottombarApp_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("eai7O", function(module, exports) {






















module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("95FGc")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9j6sg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("cYw4f")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("b6X9u")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1CMBB")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fRua9")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hBqlq"))
]).then(function() {
    return parcelRequire("hjWPk");
});

});


parcelRegister("6e14p", function(module, exports) {

$parcel$export(module.exports, "useIsStyleLoaded", function () { return $4884e15e200d2e55$export$adadf97df3f958bb; });
$parcel$export(module.exports, "makeProps", function () { return $4884e15e200d2e55$export$d4ee11730f14c667; });
$parcel$export(module.exports, "make", function () { return $4884e15e200d2e55$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $hrFTE = parcelRequire("hrFTE");
function $4884e15e200d2e55$export$3c892654f38bd67d(param) {
    var match = $g85JO.useState(function() {
        return false;
    });
    var setStyleLoaded = match[1];
    $g85JO.useEffect(function() {
        $hrFTE.insertCSS(function(param) {
            $iv6Yc._1(setStyleLoaded, function(param) {
                return true;
            });
        }, undefined);
    }, []);
    return match[0];
}
var $4884e15e200d2e55$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext(false);
var $4884e15e200d2e55$var$provider = $4884e15e200d2e55$export$a078c61943f9dbbe.Provider;
function $4884e15e200d2e55$var$CriticalCSSProvider$Provider(Props) {
    var children = Props.children;
    var isStyleLoaded = $4884e15e200d2e55$export$3c892654f38bd67d(undefined);
    return /*#__PURE__*/ $g85JO.createElement($4884e15e200d2e55$var$provider, {
        value: isStyleLoaded,
        children: children
    });
}
$4884e15e200d2e55$var$CriticalCSSProvider$Provider.displayName = "CriticalCSSProvider.Provider";
var $4884e15e200d2e55$export$2881499e37b75b9a = {
    provider: $4884e15e200d2e55$var$provider,
    make: $4884e15e200d2e55$var$CriticalCSSProvider$Provider
};
function $4884e15e200d2e55$export$adadf97df3f958bb(param) {
    return $g85JO.useContext($4884e15e200d2e55$export$a078c61943f9dbbe);
}
function $4884e15e200d2e55$export$d4ee11730f14c667(prim0, prim1, prim2) {
    var tmp = {
        children: prim0
    };
    if (prim1 !== undefined) tmp.key = prim1;
    return tmp;
}
var $4884e15e200d2e55$export$dd44f18ab656f3bb = $4884e15e200d2e55$var$CriticalCSSProvider$Provider;
 /* context Not a pure module */ 
});


parcelRegister("8wpG4", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $63453ae6f4ab9cfc$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "$$delete", function () { return $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $63453ae6f4ab9cfc$export$a47fb462a08de82f(key) {
    if (typeof key === "object") {
        var variant = key.NAME;
        if (variant === "optimizeVariant") return "mkr_variant__" + key.VAL + "";
        if (variant === "clientId") return "mkr_client_id__" + key.VAL + "";
    } else {
        if (key === "legacyClientId") return "mkr_client_id";
        if (key === "optimizePreviousEvents") return "mkr_experience_impression";
    }
    var tmp;
    if (typeof key === "object") {
        var variant$1 = key.NAME;
        tmp = variant$1 === "optimizeVariant" ? "optimizeVariant" : variant$1 === "scrollRestoration" ? "scroll-" + key.VAL : variant$1 === "history" ? "history" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "clientId" ? "clientId" : variant$1 === "favorites" ? "favorites" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "selectedMarket" ? "selectedMarket-" + key.VAL : "cart-" + key.VAL;
    } else tmp = key === "debuggerAllowed" ? "debuggerAllowed" : key === "navMenuConfig" ? "navMenuConfig" : key === "legacyClientId" ? "clientId" : key === "gridColumns" ? "gridColumns" : key === "optimizePreviousEvents" ? "optimizePreviousEvents" : "intro";
    return "smartnav__v" + String(2) + "__" + tmp;
}
function $63453ae6f4ab9cfc$export$3988ae62b71be9a3(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            return $2whNH.flatMap($loT9g.null_to_opt($2whNH.getWithDefault(storage, localStorage).getItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key))), function(value) {
                if (value === "") return;
                else return value;
            });
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be(_storage, key, value) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).setItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key), value);
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).removeItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key));
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
var $63453ae6f4ab9cfc$export$83d89fbfd8236492 = 2;
 /* No side effect */ 
});

})();
//# sourceMappingURL=Entrypoint.bs.d19faf8b.js.map
